import getHeightFromTopOfPage from './getHeightFromTopOfPage'

export function writeCss(styles: string): void {
  const head = document.head || document.getElementsByTagName('head')[0]
  writeCssToElement(head, styles)
}

export function writeCssToElement(element: HTMLElement, styles: string) {
  //const head = document.head || document.getElementsByTagName('head')[0]
  const styleEl = document.createElement('style')
  styleEl.type = 'text/css'
  if (styleEl.styleSheet) {
    styleEl.styleSheet.cssText = styles
  } else {
    styleEl.appendChild(document.createTextNode(styles))
  }
  element.appendChild(styleEl)
}

export const addClass = (el, className) => {
  if (el !== null) {
    if (el.classList) {
      el.classList.add(className)
    } else {
      el.className += ` ${className}`
    }
  }
}

export const remove = (el) => {
  if (el !== null && el.parentNode !== null) {
    el.parentNode.removeChild(el)
  }
}

export const removeClass = (el, className) => {
  if (el !== null) {
    if (el.classList) {
      el.classList.remove(className)
    } else {
      el.className = el.className.replace(
        new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'),
        ' '
      )
    }
  }
}

/**
 * Returns true if the first element is above the second element
 * @param xElement
 * @param yElement
 */
export function isXAboveY(
  xElement: HTMLElement,
  yElement: HTMLElement
): boolean {
  const xTop = getHeightFromTopOfPage(xElement)
  const yTop = getHeightFromTopOfPage(yElement)

  // Reminder: Lower number means higher on the page!
  return xTop < yTop
}

export const domReady = (fn) => {
  if (document.readyState !== 'loading') {
    fn()
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', fn)
  } else {
    document.attachEvent('onreadystatechange', () => {
      if (document.readyState !== 'loading') {
        fn()
      }
    })
  }
}

export const escapeHtml = (str): string => {
  const div = document.createElement('div')
  div.appendChild(document.createTextNode(str))

  return div.innerHTML
}

// UNSAFE with unsafe strings; only use on previously-escaped ones!
export const unescapeHtml = (escapedStr): string => {
  const div = document.createElement('div')
  div.innerHTML = escapedStr
  const child = div.childNodes[0]

  return child && child.nodeValue ? child.nodeValue : ''
}

declare global {
  interface HTMLStyleElement {
    styleSheet?: { cssText: string }
  }

  interface Document {
    webkitHidden?: string
    msHidden?: string
    mozHidden?: string
    attachEvent(event: string, listener: EventListener): boolean
    detachEvent(event: string, listener: EventListener): void
  }
}

export const sizeClassPrefix = `mv-size`
export function addAdDimensionsClass(
  event: { size: string | Array<number> },
  element: HTMLElement
): void {
  removeWildcardClass(sizeClassPrefix, element)
  const klass = `${sizeClassPrefix}-${event.size[0]}x${event.size[1]}`
  element.classList.add(klass)
}

export function removeWildcardClass(
  partialKlass: string,
  element: HTMLElement
): void {
  Array.from(element.classList).forEach((klass) => {
    if (klass.match(new RegExp(partialKlass, 'g'))) {
      element.classList.remove(klass)
    }
  })
}
